import { createSlice } from '@reduxjs/toolkit'

const   initialState ={
            token:'',
            _id:'',
            name:'',
            email:'',
            security:1000,
            userstatus:'',
            user_group:'',
            dialler_username: '',
            flg_username: '',
            flg_userid: '',
            loggedon: false,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    addauth: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateauth: (state, action) => {
      Object.assign(state, action.payload);
    },
  }
});
export const { addauth, updateauth} = authSlice.actions
export default  authSlice.reducer;